/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserMdChat} from '@fortawesome/pro-duotone-svg-icons';

const HealthScreeningIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserMdChat} {...props} />
);

export default HealthScreeningIcon;
